/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Intro_H2Inputs */

const es_l6_intro_h2 = /** @type {(inputs: L6_Intro_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La misma tarifa plana. Para un negocio, no un hobby.`)
};

const gl_l6_intro_h2 = /** @type {(inputs: L6_Intro_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A mesma tarifa plana. Para un negocio, non un hobby.`)
};

const en_l6_intro_h2 = /** @type {(inputs: L6_Intro_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The same flat rate. For a business, not a hobby.`)
};

/**
* | output |
* | --- |
* | "The same flat rate. For a business, not a hobby." |
*
* @param {L6_Intro_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_intro_h2 = /** @type {((inputs?: L6_Intro_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Intro_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_intro_h2(inputs)
	if (locale === "en") return en_l6_intro_h2(inputs)
	return es_l6_intro_h2(inputs)
});